import moment from "moment";
import { capitalizeFirstLetter } from "../string";

export const formatDateMonth = (date: Date) => {
  return capitalizeFirstLetter(moment(date).format("MMM"));
};
